<template>
  <div class="top-navigation-container h-24 flex flex-no-wrap sticky z-40 justify-between w-full xlg:w-4/5 mx-auto top-0">
    <div class="mobile-trigger flex flex-row flex-no-wrap justify-between w-full p-6 h-full">
      <img v-if="!show" @click="displayMobileMenu(true)" class="cursor-pointer" src="../../assets/img/open-menu.svg" height="50" width="30" alt="">
      <img src="../../assets/img/algo-mart.png" height="50" width="200" alt="">
    </div>
    <div class="main-menu flex flex-row justify-between flex-no-wrap px-4 py-4 mt-2">
      <div class="logo">
        <img src="../../assets/img/algo-mart.png" height="50" width="200" alt="">
      </div>
      <div class="details flex justify-end flex-no-wrap">
        <el-badge value="0" class="mr-10 mt-2">
          <i class="el-icon-message-solid text-2xl text-gray-500"></i>
        </el-badge>
        <div class="flex flex-row justify-between flex-no-wrap border-l-2 border-gray-500 px-6" style="height: 40px">
          <div class="mr-8 mt-2 ml-4">{{ name }}</div>
          <avatar class="mr-6 mt-2" :size="30" username="Jane Doe"></avatar>
          <i @click="logout()" class="el-icon-switch-button text-2xl cursor-pointer text-gray-500 mt-2"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar';

export default {
  name: 'TopNavigation',
  computed: {
    show() {
      return this.$store.state.Global.mobileMenu;
    },
    name() {
      return `${this.$store.state.AuthStore.user.first_name} ${this.$store.state.AuthStore.user.last_name}`;
    },
  },
  components: {
    Avatar,
  },
  methods: {
    async logout() {
      this.$confirm('Are you sure you want to logout?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('AuthStore/logout');

          await this.$router.push('/auth/login');
          this.$notify.success({
            title: 'Successful Logout',
            message: 'Hope to see you again.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'You cannot logout at this moment, please try again in 3 minutes.',
          });
        }
      });
    },

    async displayMobileMenu(value) {
      await this.$store.commit('Global/setProperty', { property: 'mobileMenu', payload: value });
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-trigger {
  display: flex;

  @media (min-width: 900px) {
    display: none;
  }
}

.top-navigation-container {
  background-color: #eff0f6;
  border-bottom: 2px #ccc solid;
  input {
    flex: 0 1 30%;
    border-color: #cccccc;
  }

  .main-menu {
    flex: 0 1 100%;
    display: none;

    @media (min-width: 900px) {
      display: flex;
    }
     .logo {
       flex: 0 1 60%;
     }

    .details {
      flex: 0 1 39%;
      float: right;
    }
  }
}

.el-dropdown-menu {
  width: 150px;
}
.el-icon-caret-bottom {
  font-size: 12px !important;
}
</style>
